import { render } from "./LightboxCategoryMostPurchased.vue?vue&type=template&id=1153b272"
import script from "./LightboxCategoryMostPurchased.vue?vue&type=script&lang=js"
export * from "./LightboxCategoryMostPurchased.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__